import React, { Component } from "react";

class Home extends Component {
  render() {
    return (
      <div id="Home">
        <h3>Platform Home</h3>
      </div>
    );
  }
}

export default Home;
